import { createContext, useState, useContext } from 'react'

const SearchPropertyPopupContext = createContext({
  value: false,
  setValue: function (_value: boolean) {},
})

export function SearchPropertyPopupProvider(props: {
  children: React.ReactNode
}) {
  const [value, setValue] = useState(false)

  const handleSetValue = (value: boolean) => {
    setValue(value)
  }

  const context = {
    value,
    setValue: handleSetValue,
  }

  return (
    <SearchPropertyPopupContext.Provider value={context}>
      {props.children}
    </SearchPropertyPopupContext.Provider>
  )
}
export default SearchPropertyPopupProvider

export const useSearchPropertyPopup = () =>
  useContext(SearchPropertyPopupContext)
